/**
 * The rows a stock save or upload refused, as one error toast.
 *
 * Both the Excel upload and the bulk Save report per-row rejections (the PO
 * cap, a part not assigned to the supplier, a bad quantity). The reasons are
 * what the supplier needs to fix the file, so the first few are shown rather
 * than just a count — capped at three to keep the toast readable when many
 * rows fail at once.
 */
import { toast } from 'sonner';

/**
 * Show a batch's row rejections, if any.
 *
 * @param errors - the server's per-row messages
 * @param title - the headline, e.g. "2 errors during upload"
 * @example
 * toastRowErrors(res.data.errors, `${res.data.errors.length} errors during upload`);
 */
export function toastRowErrors(errors: string[], title: string): void {
  if (errors.length === 0) return;
  const preview = errors.slice(0, 3).join('\n');
  const more = errors.length > 3 ? `\n…and ${errors.length - 3} more` : '';
  // pre-line: one reason per line — the toast collapses newlines otherwise.
  toast.error(title, {
    description: preview + more,
    duration: 10000,
    style: { whiteSpace: 'pre-line' },
  });
}
